if (!customElements.get('monogram-picker')) {
  class MonogramPicker extends HTMLElement {
    constructor() {
      super();

      this.toggle = this.querySelector('[data-monogram-picker-toggle]');
      this.letterWrapper = this.querySelector('[data-monogram-picker-letter]');
      this.letterInput = this.querySelector('[data-dropdown-input]');
      this.fieldsWrapper = this.querySelector('[data-monogram-picker-fields]');
      this.fields = Array.from(this.fieldsWrapper.querySelectorAll('input'));
      this.letterFields = this.fields.filter(field => field.hasAttribute('data-monogram-picker-letter-value'));
      this.quantityFields = this.fields.filter(field => field.hasAttribute('data-monogram-picker-quantity'));

      this.onToggle = this.onToggle.bind(this);
      this.onLetterChange = this.onLetterChange.bind(this);
      this.onQuantityChange = this.onQuantityChange.bind(this);
    }

    connectedCallback() {
      this.form = this.closest('product-information')?.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form) return;

      this.sectionId = this.form.closest('product-form')?.dataset.sectionId;
      this.form.append(this.fieldsWrapper);

      this.toggle.addEventListener('change', this.onToggle);
      this.letterWrapper.addEventListener('click', this.onLetterChange);
      this.letterWrapper.addEventListener('keydown', this.onLetterChange);
      window.eventBus?.on('qty:change', this.onQuantityChange);

      this.onToggle();
    }

    disconnectedCallback() {
      this.toggle.removeEventListener('change', this.onToggle);
      this.letterWrapper.removeEventListener('click', this.onLetterChange);
      this.letterWrapper.removeEventListener('keydown', this.onLetterChange);
      window.eventBus?.off('qty:change', this.onQuantityChange);
      this.fieldsWrapper.remove();
    }

    onToggle() {
      const enabled = this.toggle.checked;

      this.letterWrapper.classList.toggle('hidden', !enabled);
      this.letterInput.toggleAttribute('required', enabled);

      if (enabled) {
        this.letterInput.setAttribute('aria-required', 'true');
        this.fields.forEach(field => field.setAttribute('name', field.dataset.name));
      } else {
        this.letterInput.removeAttribute('aria-required');
        this.fields.forEach(field => field.removeAttribute('name'));
        this.clearErrors();
      }
    }

    clearErrors() {
      const id = this.letterInput.id;
      this.closest('product-information')
        ?.querySelectorAll(`.required-field-error[id="${id}"], .required-field-error[id="${id}Submit"]`)
        .forEach(error => error.remove());
    }

    onLetterChange(event) {
      if (!event.target.closest('[data-dropdown-options]')) return;

      this.letterFields.forEach(field => {
        field.value = this.letterInput.value;
      });
    }

    onQuantityChange({ value, sectionId }) {
      if (sectionId !== this.sectionId) return;

      this.quantityFields.forEach(field => {
        field.value = value;
      });
    }
  }

  customElements.define('monogram-picker', MonogramPicker);
}
